
<div class="dialog-header">
  <mat-icon class="close-icon" (click)="lFN_OnClose();">close</mat-icon>
</div>
<div class="w-100">
    <div class="page-info"><h3 style="font-weight: 500;margin-bottom: 25px; font-size:25px; color: hsl(220, 49%, 32%);">Receipt Details</h3></div>
</div>
<div class="grid-container">
    <div class="grid-item">
      <mat-label class="custom-mat-label">Book No.:</mat-label> {{ l_tallyReceiptModel.accountsHeader.bookNo }}
    </div>
    <div class="grid-item">
      <mat-label class="custom-mat-label">Receipt No.:</mat-label> {{ l_tallyReceiptModel.accountsDetails.receiptNo }}
    </div>
    <div class="grid-item">
      <mat-label class="custom-mat-label">Date:</mat-label> {{ l_txndate }}  
    </div>
    <div class="grid-item">
      <mat-label class="custom-mat-label">Amount:</mat-label> {{ l_amountDisplay }}
    </div>
    <div class="grid-item">
      <mat-label class="custom-mat-label">Transaction Category:</mat-label> {{ l_transactionCategory.name }}
    </div>
    <div class="grid-item">
      <mat-label class="custom-mat-label">Purpose:</mat-label> {{ l_purpose.name }}
    </div>
    <div class="grid-item">
      <mat-label class="custom-mat-label">TransactionID/Cheque No.:</mat-label> {{ l_tallyReceiptModel.accountsHeader.modeTranId }}  
    </div>
    <div class="grid-item">
      <mat-label class="custom-mat-label">Mode of Payment:</mat-label> {{ l_tallyReceiptModel.accountsHeader.modeOfPayment }}  
    </div>
    <div class="grid-item">
      <mat-label class="custom-mat-label">Bank Details:</mat-label> {{ l_tallyReceiptModel.accountsHeader.modeBankName }}  
    </div>
    <div class="grid-item">
      <mat-label class="custom-mat-label">Salutation:</mat-label> {{ l_tallyReceiptModel.accountsDetails.salutation }}
    </div>
    <div class="grid-item">
      <mat-label class="custom-mat-label">First Name:</mat-label> {{ l_tallyReceiptModel.accountsDetails.firstName }}
    </div>
    <div class="grid-item">
      <mat-label class="custom-mat-label">Middle Name:</mat-label> {{ l_tallyReceiptModel.accountsDetails.middleName }}
    </div>
    <div class="grid-item">
      <mat-label class="custom-mat-label">Last Name:</mat-label> {{ l_tallyReceiptModel.accountsDetails.lastName }}
    </div>
    <div class="grid-item">
      <mat-label class="custom-mat-label">Address:</mat-label> {{ l_tallyReceiptModel.accountsDetails.address }}
    </div>
    <div class="grid-item">
      <mat-label class="custom-mat-label">City:</mat-label> {{ l_tallyReceiptModel.accountsDetails.city }}  
    </div>
    <div class="grid-item">
      <mat-label class="custom-mat-label">Pancard:</mat-label> {{ l_tallyReceiptModel.accountsDetails.panCrdNbr }}  
    </div>
    <div class="grid-item">
      <mat-label class="custom-mat-label">Aadhar card:</mat-label> {{ l_tallyReceiptModel.accountsDetails.aadharCrdNbr }}  
    </div>
    <div class="grid-item">
      <mat-label class="custom-mat-label">Receipt Notes:</mat-label> {{ l_tallyReceiptModel.accountsDetails.notes }}
    </div>
    <div class="grid-item">
      <mat-label class="custom-mat-label">Collected By:</mat-label> {{ l_tallyReceiptModel.accountsDetails.collectedBy }}
    </div>
    <div class="grid-item">
      <mat-label class="custom-mat-label">Status:</mat-label> {{ ((l_tallyReceiptModel.accountsHeader.status === true) ? 'Yes': 'No') }}
    </div>
    <div class="grid-item">
      <mat-label class="custom-mat-label">Mapping External:</mat-label> {{ ((l_tallyReceiptModel.accountsHeader.mapexternal === true) ? 'Yes': 'No') }}
    </div>

    <div class="grid-item">
      <mat-label class="custom-mat-label">Created By:</mat-label> {{ l_tallyReceiptModel.createdBy }}
    </div>
    <div class="grid-item">
      <mat-label class="custom-mat-label">Created Date:</mat-label> {{ l_createddate }}
    </div>
    <div class="grid-item">
      <mat-label class="custom-mat-label">Updated By:</mat-label> {{ l_tallyReceiptModel.updatedBy }}
    </div>
    <div class="grid-item">
      <mat-label class="custom-mat-label">Updated Date:</mat-label> {{ l_updateddate }}
    </div>
  </div>
  